// extracted by mini-css-extract-plugin
export default {"container":"HeadingTop_container__rDNHF","heading":"HeadingTop_heading__bztT+","subheading":"HeadingTop_subheading__OHADo","hr":"HeadingTop_hr__lT7mJ"};